import React from 'react';
import { BackHeader } from '../../components/family/ui';
import { usePageTitle } from '../../hooks/usePageTitle';

/**
 * Egy meglévő oldal (tagdíj, dokumentumok, fiók, súgó) a családi nézetben: fölé
 * egy vissza gomb kerül a "Profil" fülre, a tartalom változatlan.
 */
const FamilySubPage: React.FC<{ children: React.ReactNode; title?: string }> = ({ children, title }) => {
  // Cím nélkül a beágyazott oldal (pl. Dokumentumok) maga állítja be - az üres
  // címet a usePageTitle figyelmen kívül hagyja
  usePageTitle(title ?? '');
  return (
    <div>
      <BackHeader backLabel="Profil" back="/me" />
      {title && <h1 className="mb-4 text-[26px] font-bold leading-tight text-gray-900">{title}</h1>}
      {children}
    </div>
  );
};

export default FamilySubPage;
